import { useEffect, useState } from 'react'
import type { HierarchyType } from '../API/rtk-query-api/store/tmsApi'
import { useHierarchiesQuery } from '../API/rtk-query-api/store/tmsApi'

export const useHierarchies = () => {
  const [hierarchies, setHierarchies] = useState<Array<HierarchyType>>()

  const { data, isLoading, isFetching, isError } = useHierarchiesQuery()

  useEffect(() => {
    if (data && !isLoading && !isFetching) {
      setHierarchies(data)
    }
  }, [data, isLoading, isFetching])

  return { hierarchies, isLoading: isLoading || isFetching, isError }
}
